import api from "./Api";

class ProdutoTributacaoAtualizacaoService {
  GetCampos() {
    return api
      .get("/v1/Produto/Tributacao/Atualizacao/Campos")
      .then((response) => {
        return response.data;
      });
  }

  Exportar(payload) {
    return api
      .post("/v1/Produto/Tributacao/Atualizacao/Exportar", payload)
      .then((response) => {
        return response.data;
      });
  }

  Validar(payload) {
    return api
      .post("/v1/Produto/Tributacao/Atualizacao/Validar", payload)
      .then((response) => {
        return response.data;
      });
  }

  Aplicar(payload) {
    return api
      .post("/v1/Produto/Tributacao/Atualizacao/Aplicar", payload)
      .then((response) => {
        return response.data;
      });
  }
}

export default new ProdutoTributacaoAtualizacaoService();
